# This gets automatically populated bij gulp

exports.date = 1487329035
exports.branch = "master"
exports.hash = "8db1dc8"
exports.build = 2503
exports.version = "#{exports.branch}/#{exports.hash}"



// WEBPACK FOOTER //
// ./build/Version.coffee